.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 12px;
}

.factRow {
    display: grid;
    grid-template-columns: 160px 1fr auto;
    align-items: center;
    column-gap: 8px;
}

@media (max-width: 768px) {
    .factRow {
        grid-template-columns: 100px 1fr auto;
    }

    .factLabel {
        font-size: 12px;
    }
}

.factLabel {
    min-height: 40px;
    display: flex;
    align-items: center;
}

.addRowButton {
    width: 100%;
    justify-content: center;
    border-style: dashed;
}

.actions {
    display: flex;
    justify-content: flex-end;
}

.saveButton {
    height: 37.13px;
}

.inheritedParentLink {
    padding: 0;
    min-width: 0;
    max-width: 220px;
    vertical-align: bottom;
    font: inherit;
    text-transform: none;
    text-decoration: underline;
    display: inline-block;
}
